import { rankingList } from '@/mocks/animeData';

const rankBadge: Record<string, string> = {
  甜番: 'bg-primary-100 text-primary-700',
  纯爱: 'bg-secondary-100 text-secondary-900',
  狗粮: 'bg-accent-100 text-accent-700',
  暧昧: 'bg-background-200 text-foreground-700',
};

const rankNumClass = ['text-primary-500', 'text-accent-500', 'text-secondary-500', 'text-foreground-400', 'text-foreground-400'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium">
              <i className="ri-trophy-line"></i>
              本周心动榜
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">恋爱甜番 Top5 排行榜</h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
              根据近期热度与追番同好的讨论度整理，榜单每周更新，帮你快速锁定大家都在看的心动之作。
            </p>
          </div>
          <a
            href="#subscribe"
            className="inline-flex items-center gap-1.5 px-4 py-2 text-sm text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md whitespace-nowrap transition-colors"
          >
            <i className="ri-notification-3-line"></i>
            开榜提醒我
          </a>
        </div>

        <div className="mt-10 flex flex-col gap-4">
          {rankingList.map((item, idx) => (
            <div
              key={item.id}
              className="group flex flex-col sm:flex-row sm:items-center gap-4 rounded-lg bg-background-100 border border-background-200/70 p-4 md:p-5 hover:border-primary-200 hover:bg-background-50 transition-colors"
            >
              <span className={`w-10 h-10 flex items-center justify-center shrink-0 font-heading text-2xl ${rankNumClass[idx]}`}>
                {idx + 1}
              </span>

              <div className="flex items-center gap-4 flex-1 min-w-0">
                <img
                  src={item.image}
                  alt={`${item.title}心动榜剧照`}
                  className="w-16 h-16 md:w-20 md:h-20 shrink-0 object-cover rounded-md"
                />
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-lg text-foreground-950 truncate">{item.title}</h3>
                    <span className={`px-2 py-0.5 text-xs rounded-full whitespace-nowrap ${rankBadge[item.category]}`}>
                      {item.category}
                    </span>
                  </div>
                  <p className="mt-1 text-sm text-foreground-600 truncate">{item.tagline}</p>
                </div>
              </div>

              <div className="flex items-center gap-4 sm:gap-6 shrink-0">
                <div className="flex items-center gap-1 text-primary-500" aria-label={`${item.sweetness} 分甜度`}>
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className={i < item.sweetness ? 'ri-heart-fill' : 'ri-heart-line'}></i>
                  ))}
                </div>
                <span className="inline-flex items-center gap-1 px-3 py-1.5 text-sm font-bold text-accent-700 bg-accent-100 rounded-md whitespace-nowrap">
                  <i className="ri-fire-fill text-accent-500"></i>
                  {item.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}